import React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';
import {HEART__24, HEART__16} from '@homeaway/svg-defs';

function Scratchpad({iconSize, label, tripboard}) {
    const scratchpadLink = (
        <div className="site-header-nav__scratchpad" data-bypass="true">
            <SVGIcon inlineFlex markup={iconSize === 'sm' ? HEART__16 : HEART__24}/>
            <span className="site-header-nav__icon-label">{label}</span>
        </div>
    );

    if (tripboard) {
        return tripboard({scratchpadLink});
    }

    return scratchpadLink;
}

Scratchpad.propTypes = {
    iconSize: PropTypes.string,
    label: PropTypes.string,
    tripboard: PropTypes.func
};

export {Scratchpad};
